// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"308":"31c21078","453":"94b5b7bf"}[chunkId] + ".chunk.js";
};